<table class="billing-table">
  <thead>
    <tr>
      <th>Date</th>
      <th>Type</th>
      <th>Description</th>
      <th class="col-num">Amount</th>
      @if (showStatus) {
        <th>Status</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of rows; track row.id) {
      <tr>
        <td>{{ row.createdAt | date:'MMM d, y, HH:mm' }}</td>
        <td><span [class]="'txn-kind-badge txn-kind-badge--' + row.kind">{{ kindLabel(row.kind) }}</span></td>
        <td>{{ row.description || '—' }}</td>
        <td class="col-num" [class.amount--credit]="row.isCredit" [class.amount--debit]="!row.isCredit">
          {{ row.isCredit ? '+' : '−' }}{{ (row.amountCents < 0 ? -row.amountCents : row.amountCents) | money: row.currency }}
        </td>
        @if (showStatus) {
          <td>
            <span class="txn-status-badge">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 11A5 5 0 106 1a5 5 0 000 10Zm2.28-6.22a.75.75 0 00-1.06-1.06L5.5 5.44 4.28 4.22a.75.75 0 00-1.06 1.06l1.75 1.75a.75.75 0 001.06 0l2.75-2.75Z" fill="currentColor"/>
              </svg>
              {{ row.status | titlecase }}
            </span>
          </td>
        }
      </tr>
    }
  </tbody>
</table>
